import React, { Component } from 'react';
import './Events.css';

export class Events extends Component {
    render() {
        return (
        <div class="container page-content">
            <div class="page-header">
                <h2>Calendrier 2019-2020</h2> 
            </div>
            <hr class="hrNeonBlue" />
            <p class="lead">Plusieurs événements provinciaux, nationaux et même internationaux sont organisés chaque année par la grande famille ISKF. Ils représentent des occasions d'apprentissage et de développement pour tous.</p>
            <article>
                <h2 class="year-label">2019</h2>
                <div class="posters">
                    <img src="images/events/AfficheCampNational2019.jpg" alt="Affiche camp national 2019" />
                    <img src="images/events/ChampionnatJunior2019.jpg" alt="Championnat junior 2019" />
                </div> 
                <div class="row event-row">
                    <div class="col-md-3 red-text">OCT 31-3 NOV</div>
                    <div class="col-md-6">
                        <strong>Camp National - ISKF Canada</strong><br />
                        <i>Sensei David Jones et Tony Tam</i><br />
                        <a target="_blank" href="pdf/news/HoraireCampNational2019.pdf">Informations</a>
                    </div>
                    <div class="col-md-3">QUÉBEC</div>
                </div>
                <div class="row event-row">
                    <div class="col-md-3 red-text">NOVEMBRE 21-24</div>
                    <div class="col-md-6">
                        <strong>Sud Américain - Master Camp 2019</strong><br />
                    </div>
                    <div class="col-md-3">URAGUAY</div>
                </div>
                <div class="row event-row">
                    <div class="col-md-3 red-text">NOVEMBRE 23</div>
                    <div class="col-md-6">
                        <strong>3e Open Shotokan</strong><br />
                    </div>
                    <div class="col-md-3">SEPT ÎLES</div>
                </div>
                <hr/>

                <h2 class="year-label">2020</h2> 
                <div class="row event-row">
                    <div class="col-md-3 red-text">FÉVRIER 20-22</div>
                    <div class="col-md-6">
                        <strong>Québec Kangeiko 2020</strong><br />
                        <i>SHIHAN Hiroyoshi Okazaki 9<sup>e</sup> Dan</i><br />
                    </div>
                    <div class="col-md-3">QUÉBEC</div>
                </div>
                <div class="row event-row">
                    <div class="col-md-3 red-text">FÉVRIER 22</div>
                    <div class="col-md-6">
                        <strong>SHOTOSHOW 2020</strong><br />
                        <i>Financement de Québec ISKF</i>
                    </div>
                    <div class="col-md-3">GRAND CAFÉ QUÉBEC</div>
                </div>
                <div class="row event-row">
                    <div class="col-md-3 red-text">AVRIL 11</div>
                    <div class="col-md-6">
                        <strong>Championnat Provincial QCISKF</strong><br />
                        <i>Sélection Équipe du Québec 2020</i>
                    </div>
                    <div class="col-md-3">LES ESCOUMINS</div>
                </div>
                <div class="row event-row">
                    <div class="col-md-3 red-text">MAI 14-17</div>
                    <div class="col-md-6">
                        <strong>39<sup>e</sup> Championnat National</strong><br />
                        <i>Camp National ISKF Canada</i>
                    </div>
                    <div class="col-md-3">HALIFAX</div>
                </div>
                <div class="row event-row">
                    <div class="col-md-3 red-text">JUIN 5-12</div>
                    <div class="col-md-6">
                        <strong>54<sup>e</sup> ISKF Master Camp</strong><br />
                        <i>International Shotokan Karate Federation</i>
                    </div>
                    <div class="col-md-3">PHILADELPHIE</div>
                </div>
                <div class="row event-row">
                    <div class="col-md-3 red-text">JUILLET 23-26</div>
                    <div class="col-md-6">
                        <strong>8<sup>e</sup> Calgary Summer Camp</strong><br />
                        <i>ISKF Canada - Calgary</i>
                    </div>
                    <div class="col-md-3">CALGARY</div>
                </div>
                <div class="row event-row">
                    <div class="col-md-3 red-text">JUIL 24-9 AOÛT</div>
                    <div class="col-md-6">
                        <strong>Le Karaté aux Olympiques</strong><br />
                        <i>Olympiques d'été 2020</i>
                    </div>
                    <div class="col-md-3">TOKYO, JAPON</div>
                </div>
                <div class="row event-row">
                    <div class="col-md-3 red-text">AOÛT 20-23</div>
                    <div class="col-md-6">
                        <strong>Championnat du monde</strong><br />
                        <i>ISKF Shotocup 2020</i><br />
                        <a target="_blank" href="pdf/news/ShotocupLondon2020.pdf">Informations</a>
                    </div>
                    <div class="col-md-3">LONDRES, ANGLETERRE</div>
                </div>
            </article>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/pages/event/Events.js